<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="card-title">{{ cardTitle }}</div>
      <button 
        v-if="dataRow && dataRow.id" 
        type="button" 
        class="btn btn-primary btn-sm" 
        @click="printPaymentInfo"
      >
        <i class="fas fa-print"></i> طباعة
      </button>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div id="printable-area" class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الاسم:</label>
            <div>{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الجوال:</label>
            <div>{{ (dataRow.User)? dataRow.User.mobile : 'غير معروف' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الكارت:</label>
            <div>{{ dataRow.card }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الإنتهاء:</label>
            <div>{{ dataRow.expYear }}-{{ dataRow.expMonth }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الرقم المرجعي:</label>
            <div>{{ dataRow.reference }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الوصف:</label>
            <div>{{ dataRow.description }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">القيمة:</label>
            <div>{{ dataRow.amount }}  ريال</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع العملية:</label>
            <div>{{ transactionTypeLabel(dataRow.transactionType) }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">approved:</label>
            <div>{{ dataRow.approved }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">status:</label>
            <div>{{ dataRow.status }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">responseSummary:</label>
            <div>{{ dataRow.responseSummary }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الطلب:</label>
            <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">رد البنك:</label>
            <div>{{ JSON.parse(dataRow.checoutResponse) }}</div>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';

export default {
  name: 'PaymentsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
    }
  },
  methods: {
  transactionTypeLabel(transactionType) {
    if (transactionType === 'plus') return 'إضافة';
    if (transactionType === 'minus') return 'خصم';
    return '—';
  },
  formatDate,
  printPaymentInfo() {
    const printArea = document.getElementById('printable-area');
    
    if (!printArea) return;
    
    const printContent = printArea.cloneNode(true);
    
    const style = document.createElement('style');
    style.textContent = `
      @media print {
        body {
          font-family: Arial, sans-serif;
          direction: rtl;
          padding: 20px;
        }
        .form-label {
          font-weight: bold;
          margin-bottom: 5px;
          display: block;
        }
        .row {
          margin-bottom: 15px;
          page-break-inside: avoid;
        }
        .col-12, .col-sm-6 {
          margin-bottom: 10px;
        }
        .date-format {
          margin-top: 0;
        }
      }
    `;
    
    const printWindow = window.open('', '_blank');
    
    if (printWindow) {
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>تفاصيل الدفع - ${this.dataRow.User ? this.dataRow.User.name : 'Payment Details'}</title>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet">
          ${style.outerHTML}
        </head>
        <body>
          <div class="print-header" style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 10px;">
            <h2>${this.cardTitle}</h2>
            <p style="font-size: 14px; color: #555; margin-top: 5px;">شركة أحمد المحيسني العقارية للعقارات وإدارة الأملاك</p>
            <p>تاريخ الطباعة: ${new Date().toLocaleDateString('ar-SA')}</p>
          </div>
          ${printContent.outerHTML}
          <div class="print-footer" style="text-align: center; margin-top: 30px; border-top: 1px solid #ccc; padding-top: 10px; font-size: 12px;">
            <p>شركة أحمد المحيسني العقارية للعقارات وإدارة الأملاك</p>
            <p>تم الطباعة من نظام المدفوعات</p>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
      
      printWindow.onload = () => {
        printWindow.print();
        //Close the window after printing 
        // printWindow.onafterprint = () => printWindow.close();
      };
    } else {
      window.print();
    }
  }
},
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
    }
    this.statusChoices = this.statusObject;
  }
}
</script>

<style scoped>
@media print {
  .card-header button,
  .errorAlert,
  .successAlert {
    display: none !important;
  }
  
  .card {
    border: none !important;
    box-shadow: none !important;
  }
  
  .card-body {
    padding: 0 !important;
  }
}
</style>